var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "container-sm mt-6" },
    [
      !_vm.clienteModal
        ? _c(
            "ConditionalTeleport",
            { attrs: { to: "page-header-actions", routes: _vm.moduleRoutes } },
            [
              _c("BasePageHeader", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "actions",
                      fn: function() {
                        return [
                          _c("BaseSplitButton", {
                            attrs: {
                              label: "Selecionar outra simulação",
                              items: _vm.headerMenuActions
                            },
                            on: {
                              click: _vm.openSearchHistory,
                              select: _vm.onHeaderAction
                            }
                          })
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  1982524114
                )
              })
            ],
            1
          )
        : _vm._e(),
      !_vm.clienteAtual.name
        ? _c("FeedbackWrapper", {
            attrs: {
              bordered: "",
              "no-data": true,
              message: "Selecione um cliente para simular",
              "min-height": 360
            }
          })
        : _vm.loading
        ? _c(
            "div",
            {
              staticClass:
                "row justify-content-center mt-n3 simulador-comparativo__skeleton",
              staticStyle: { "max-width": "-webkit-fill-available" }
            },
            [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "az-card-bordered" },
                  [_c("BaseLoadingSkeleton", { attrs: { height: "56px" } })],
                  1
                )
              ]),
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "az-card-bordered" },
                  [_c("BaseLoadingSkeleton", { attrs: { height: "220px" } })],
                  1
                )
              ]),
              _c("div", { staticClass: "col-4" }, [
                _c(
                  "div",
                  { staticClass: "az-card-bordered h-100" },
                  [_c("BaseLoadingSkeleton", { attrs: { height: "180px" } })],
                  1
                )
              ]),
              _c("div", { staticClass: "col-4" }, [
                _c(
                  "div",
                  { staticClass: "az-card-bordered h-100" },
                  [_c("BaseLoadingSkeleton", { attrs: { height: "180px" } })],
                  1
                )
              ]),
              _c("div", { staticClass: "col-4" }, [
                _c(
                  "div",
                  { staticClass: "az-card-bordered h-100" },
                  [_c("BaseLoadingSkeleton", { attrs: { height: "180px" } })],
                  1
                )
              ])
            ]
          )
        : !_vm.simulacaoDireita.hash_code
        ? _c("FeedbackWrapper", {
            attrs: {
              bordered: "",
              "no-data": true,
              message: "Selecione uma simulação",
              "min-height": 360
            },
            scopedSlots: _vm._u([
              {
                key: "button",
                fn: function() {
                  return [
                    _c(
                      "BaseButton",
                      {
                        attrs: { dark: "", outline: "" },
                        on: { click: _vm.openSearchHistory }
                      },
                      [_vm._v(" Selecionar simulação ")]
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        : _c(
            "div",
            {
              staticClass: "row justify-content-center mt-n3",
              staticStyle: { "max-width": "-webkit-fill-available" }
            },
            [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  {
                    staticClass: "az-card-bordered d-flex align-center",
                    staticStyle: { "max-width": "100%" }
                  },
                  [
                    _c(
                      "v-edit-dialog",
                      {
                        attrs: {
                          "return-value": _vm.simulacaoDireita.nome_simulacao,
                          large: "",
                          "cancel-text": "Cancelar",
                          "save-text": "Salvar"
                        },
                        on: {
                          "update:returnValue": function($event) {
                            return _vm.$set(
                              _vm.simulacaoDireita,
                              "nome_simulacao",
                              $event
                            )
                          },
                          "update:return-value": function($event) {
                            return _vm.$set(
                              _vm.simulacaoDireita,
                              "nome_simulacao",
                              $event
                            )
                          },
                          save: _vm.salvarNomeSimulacao
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "input",
                            fn: function() {
                              return [
                                _c("v-text-field", {
                                  attrs: {
                                    dense: "",
                                    "hide-details": "",
                                    label: "Simulação"
                                  },
                                  model: {
                                    value: _vm.simulacaoDireita.nome_simulacao,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.simulacaoDireita,
                                        "nome_simulacao",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "simulacaoDireita.nome_simulacao"
                                  }
                                })
                              ]
                            },
                            proxy: true
                          }
                        ])
                      },
                      [
                        _c(
                          "span",
                          {
                            ref: "nomeSpan",
                            staticClass:
                              "az-ds-card-title simulador-comparativo__nome"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.simulacaoDireita.nome_simulacao) +
                                " "
                            )
                          ]
                        )
                      ]
                    ),
                    _c("v-spacer"),
                    _c("BaseSplitButton", {
                      attrs: {
                        label: "Editar nome",
                        items: _vm.cardMenuActions
                      },
                      on: { click: _vm.openEditNome, select: _vm.onCardAction }
                    })
                  ],
                  1
                )
              ]),
              _vm.simulationError
                ? _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c(
                        "BaseAlert",
                        {
                          attrs: { icon: "warning", iconColor: "warning" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "button",
                                fn: function() {
                                  return [
                                    _vm.restricoes_simulacao.tipo_simulador
                                      ? _c(
                                          "BaseButton",
                                          {
                                            staticClass: "mx-10",
                                            attrs: {
                                              small: "",
                                              dark: "",
                                              outline: "",
                                              "min-width": "80px"
                                            },
                                            on: { click: _vm.toRestricoes }
                                          },
                                          [_vm._v(" Alterar restrições ")]
                                        )
                                      : _vm._e()
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            2344788789
                          )
                        },
                        [_vm._v(" " + _vm._s(_vm.simulationError) + " ")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.alertMessages.length
                ? _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c(
                        "BaseAlert",
                        { attrs: { icon: "info", iconColor: "info" } },
                        _vm._l(_vm.alertMessages, function(m) {
                          return _c("span", {
                            key: m,
                            domProps: { innerHTML: _vm._s(m) }
                          })
                        }),
                        0
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", { staticClass: "col-4" }, [
                _c(
                  "div",
                  { staticClass: "az-card-bordered h-100" },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex mb-10" },
                      [
                        _c("h2", { staticClass: "az-ds-card-title" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.simulacaoEsquerda.hash
                                  ? _vm.simulacaoEsquerda.nome_simulacao
                                  : "Carteira atual"
                              ) +
                              " "
                          )
                        ]),
                        _c("v-spacer"),
                        _c(
                          "BaseModal",
                          {
                            staticClass: "d-inline",
                            attrs: {
                              "max-width": "80%",
                              "destroy-on-close": true,
                              height: "600px"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "button",
                                fn: function() {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex align-center",
                                        on: { click: _vm.abrirModal }
                                      },
                                      [
                                        _c(
                                          "small",
                                          {
                                            staticClass:
                                              "az-text-small az-muted mr-1"
                                          },
                                          [_vm._v(" Ampliar ")]
                                        ),
                                        _c("icon-svg", {
                                          attrs: {
                                            name: "mdi-fullscreen",
                                            size: 16,
                                            color: "#8E8E8E"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ])
                          },
                          [
                            _c(
                              "div",
                              [
                                _c("Title", {
                                  attrs: { title: "Carteira atual" }
                                }),
                                _c("line-chart", {
                                  ref: "rentabilidade2",
                                  attrs: {
                                    "chart-data": _vm.lineDataEsquerda,
                                    options: _vm.lineOptions,
                                    styles: { height: "80vh", width: "100%" }
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticStyle: { "margin-bottom": "52px" } },
                      [
                        _c("line-chart", {
                          ref: "rentabilidade",
                          attrs: {
                            "chart-data": _vm.lineDataEsquerda,
                            options: _vm.lineOptions
                          }
                        })
                      ],
                      1
                    ),
                    _c("v-divider", { staticClass: "my-5" }),
                    _c(
                      "h2",
                      {
                        staticClass: "az-text-primary az-size-14 font-semibold"
                      },
                      [_vm._v(" Estatísticas anualizadas ")]
                    ),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-3" }, [
                        _c("small", { staticClass: "az-text-small" }, [
                          _vm._v("Rent.")
                        ])
                      ]),
                      _c("div", { staticClass: "col-3 text-right" }, [
                        _c(
                          "small",
                          { staticClass: "az-text-small font-bold" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.toPercent(
                                    (_vm.estatisticaEsquerda
                                      .retorno_anualizado ||
                                      _vm.estatisticaEsquerda.rp_acumulado) *
                                      100
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "col-3" }, [
                        _c("small", { staticClass: "az-text-small" }, [
                          _vm._v("Rent. Rel.")
                        ])
                      ]),
                      _c("div", { staticClass: "col-3 text-right" }, [
                        _c(
                          "small",
                          { staticClass: "az-text-small font-bold" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.toPercent(
                                    (_vm.estatisticaEsquerda
                                      .retorno_anualizado_relativo ||
                                      _vm.estatisticaEsquerda.coef_cdi) * 100
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "col-3" }, [
                        _c("small", { staticClass: "az-text-small" }, [
                          _vm._v("Vol.")
                        ])
                      ]),
                      _c("div", { staticClass: "col-3 text-right" }, [
                        _c(
                          "small",
                          { staticClass: "az-text-small font-bold" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.toPercent(
                                    _vm.estatisticaEsquerda.vol * 100
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "col-3" }, [
                        _c("small", { staticClass: "az-text-small" }, [
                          _vm._v("Sharpe")
                        ])
                      ]),
                      _c("div", { staticClass: "col-3 text-right" }, [
                        _c(
                          "small",
                          { staticClass: "az-text-small font-bold" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatNumber(
                                    _vm.estatisticaEsquerda.sharp_ratio || 0
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "col-5" }, [
                        _c("small", { staticClass: "az-text-small" }, [
                          _vm._v(" Janela de tempo ")
                        ])
                      ]),
                      _c("div", { staticClass: "col-7 text-right" }, [
                        _c(
                          "small",
                          { staticClass: "az-text-small font-bold" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.lineDataEsquerda.labels[0] || "-") +
                                " " +
                                _vm._s(
                                  _vm.lineDataEsquerda.labels.length > 0
                                    ? " a " +
                                        _vm.lineDataEsquerda.labels[
                                          _vm.lineDataEsquerda.labels.length - 1
                                        ] || ""
                                    : ""
                                ) +
                                " "
                            )
                          ]
                        )
                      ])
                    ])
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "col-4" }, [
                _c(
                  "div",
                  { staticClass: "az-card-bordered h-100" },
                  [
                    _c("p", { staticClass: "mb-10" }, [
                      _c("strong", { staticClass: "az-ds-card-title" }, [
                        _vm._v(" Perfil de investidor: ")
                      ]),
                      _c(
                        "small",
                        { staticClass: "az-text-small az-muted font-bold" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.restricoes_simulacao.perfil ||
                                  "Desconhecido"
                              ) +
                              " "
                          )
                        ]
                      )
                    ]),
                    _vm._l(Object.values(_vm.compEstr), function(c, index) {
                      return _c(
                        "div",
                        {
                          key: c.name,
                          staticClass: "row mb-5 justify-content-center"
                        },
                        [
                          _c("div", {
                            style: {
                              width: "5px",
                              "background-color": c.color,
                              "border-radius": "30px"
                            }
                          }),
                          _c("div", { staticClass: "col-3" }, [
                            _c("small", { staticClass: "az-text-small" }, [
                              _vm._v(
                                " " + _vm._s(_vm.toPercent(c.esquerda)) + " "
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "col-5 text-center" }, [
                            _c("small", { staticClass: "az-text-small" }, [
                              _vm._v(" " + _vm._s(c.name) + " ")
                            ])
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-3" },
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "", disabled: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "small",
                                              _vm._g(
                                                {
                                                  staticClass: "az-text-small"
                                                },
                                                on
                                              ),
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.toPercent(c.direita)
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  c.direita - c.esquerda > 0
                                    ? _c("span", [
                                        _vm._v(
                                          " Participação simulada " +
                                            _vm._s(
                                              _vm.toPercent(
                                                c.direita - c.esquerda
                                              )
                                            ) +
                                            " maior que a atual "
                                        )
                                      ])
                                    : c.direita - c.esquerda < 0
                                    ? _c("span", [
                                        _vm._v(
                                          " Participação simulada " +
                                            _vm._s(
                                              _vm.toPercent(
                                                c.esquerda - c.direita
                                              )
                                            ) +
                                            " menor que a atual "
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          " Participação simulada condizente com a atual "
                                        )
                                      ])
                                ]
                              )
                            ],
                            1
                          ),
                          _c("div", {
                            style: {
                              width: "5px",
                              "background-color": c.color,
                              "border-radius": "30px"
                            }
                          })
                        ]
                      )
                    })
                  ],
                  2
                )
              ]),
              _c("div", { staticClass: "col-4" }, [
                _c(
                  "div",
                  { staticClass: "az-card-bordered h-100" },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex mb-10" },
                      [
                        _c("h2", { staticClass: "az-ds-card-title" }, [
                          _vm._v(" Backtest simulada ")
                        ]),
                        _c("v-spacer"),
                        _c(
                          "BaseModal",
                          {
                            staticClass: "d-inline",
                            attrs: {
                              "max-width": "80%",
                              "destroy-on-close": true,
                              height: "600px"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "button",
                                fn: function() {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex align-center",
                                        on: { click: _vm.abrirModal }
                                      },
                                      [
                                        _c(
                                          "small",
                                          {
                                            staticClass:
                                              "az-text-small az-muted mr-1"
                                          },
                                          [_vm._v(" Ampliar ")]
                                        ),
                                        _c("icon-svg", {
                                          attrs: {
                                            name: "mdi-fullscreen",
                                            size: 16,
                                            color: "#8E8E8E"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ])
                          },
                          [
                            _c(
                              "div",
                              [
                                _c("Title", {
                                  attrs: { title: "Backtest simulada" }
                                }),
                                _c("line-chart", {
                                  ref: "rentabilidade2",
                                  attrs: {
                                    "chart-data": _vm.lineDataDireita,
                                    options: _vm.lineOptions,
                                    styles: { height: "80vh", width: "100%" }
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c("line-chart", {
                      ref: "rentabilidade",
                      attrs: {
                        "chart-data": _vm.lineDataDireita,
                        options: _vm.lineOptions
                      }
                    }),
                    _c(
                      "div",
                      { staticClass: "d-flex" },
                      [
                        _c("v-spacer"),
                        _c(
                          "v-menu",
                          {
                            attrs: {
                              top: "",
                              "offset-y": "",
                              "close-on-content-click": false
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "div",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "d-flex align-center"
                                          },
                                          "div",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c(
                                          "small",
                                          {
                                            staticClass:
                                              "az-text-small az-muted mr-1"
                                          },
                                          [_vm._v(" Visualizar benchmarks: ")]
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              icon: "",
                                              small: "",
                                              color: "primary"
                                            }
                                          },
                                          [
                                            _c("icon-svg", {
                                              attrs: {
                                                name: "mdi-plus",
                                                size: 16,
                                                color: "primary"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ])
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "bg-white p-5",
                                staticStyle: {
                                  "border-radius": "6px",
                                  width: "200px",
                                  "max-height": "320px",
                                  "overflow-y": "auto"
                                }
                              },
                              _vm._l(_vm.BENCHMARKS, function(bench) {
                                return _c("v-checkbox", {
                                  key: bench.id,
                                  attrs: {
                                    label: bench.nome,
                                    value: bench.id,
                                    color: "primary",
                                    dense: "",
                                    "hide-details": ""
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.benchmark_graph_changed = true
                                    }
                                  },
                                  model: {
                                    value: _vm.benchmarks_selecionados_grafico,
                                    callback: function($$v) {
                                      _vm.benchmarks_selecionados_grafico = $$v
                                    },
                                    expression:
                                      "benchmarks_selecionados_grafico"
                                  }
                                })
                              }),
                              1
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c("v-divider", { staticClass: "my-5" }),
                    _c(
                      "div",
                      {
                        staticClass: "d-flex flex-inline",
                        staticStyle: { "align-items": "baseline" }
                      },
                      [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "az-text-primary az-size-14 font-semibold mr-1"
                          },
                          [_vm._v(" Estatísticas anualizadas ")]
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "", "x-small": "" },
                            on: { click: _vm.entendaMaisEstatistica }
                          },
                          [
                            _c("icon-svg", {
                              attrs: { name: "info-circle", size: 16 }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-3" }, [
                        _c("small", { staticClass: "az-text-small" }, [
                          _vm._v("Rent.")
                        ])
                      ]),
                      _c("div", { staticClass: "col-3 text-right" }, [
                        _c(
                          "small",
                          { staticClass: "az-text-small font-bold" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.toPercent(
                                    (
                                      _vm.estatisticaDireita[
                                        "backtest-statistics"
                                      ] || {}
                                    ).retorno_anualizado * 100 || 0
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "col-3" }, [
                        _c("small", { staticClass: "az-text-small" }, [
                          _vm._v("Rent. Rel.")
                        ])
                      ]),
                      _c("div", { staticClass: "col-3 text-right" }, [
                        _c(
                          "small",
                          { staticClass: "az-text-small font-bold" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.toPercent(
                                    (
                                      _vm.estatisticaDireita[
                                        "backtest-statistics"
                                      ] || {}
                                    ).retorno_anualizado_relativo * 100 || 0
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "col-3" }, [
                        _c("small", { staticClass: "az-text-small" }, [
                          _vm._v("Vol.")
                        ])
                      ]),
                      _c("div", { staticClass: "col-3 text-right" }, [
                        _c(
                          "small",
                          { staticClass: "az-text-small font-bold" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.toPercent(
                                    _vm.estatisticaDireita.vol * 100 || 0
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "col-3" }, [
                        _c("small", { staticClass: "az-text-small" }, [
                          _vm._v("Sharpe")
                        ])
                      ]),
                      _c("div", { staticClass: "col-3 text-right" }, [
                        _c(
                          "small",
                          { staticClass: "az-text-small font-bold" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatNumber(
                                    _vm.estatisticaDireita.sharp_ratio || 0
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "col-5" }, [
                        _c("small", { staticClass: "az-text-small" }, [
                          _vm._v("Janela de tempo")
                        ])
                      ]),
                      _c("div", { staticClass: "col-7 text-right" }, [
                        _vm.backtestDireita
                          ? _c(
                              "small",
                              { staticClass: "az-text-small font-bold" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.backtestDireita.portfolio
                                        ? _vm.backtestDireita.portfolio
                                            .data[0] || "-"
                                        : "-"
                                    ) +
                                    " " +
                                    _vm._s(
                                      _vm.backtestDireita.portfolio &&
                                        _vm.backtestDireita.portfolio.data
                                          .length > 0
                                        ? " a " +
                                            _vm.backtestDireita.portfolio.data[
                                              _vm.backtestDireita.portfolio.data
                                                .length - 1
                                            ] || ""
                                        : ""
                                    ) +
                                    " "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ])
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "az-card-bordered h-100 d-flex flex-column justify-content-center"
                  },
                  [
                    _c("h2", { staticClass: "az-ds-card-title mb-10" }, [
                      _vm._v(" Liquidez carteira atual ")
                    ]),
                    _c("ShowLiquidez", {
                      attrs: { values: _vm.liquidezEsquerda, size: 0 }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "az-card-bordered h-100 d-flex flex-column justify-content-center"
                  },
                  [
                    _c("h2", { staticClass: "az-ds-card-title mb-10" }, [
                      _vm._v(" Liquidez simulada ")
                    ]),
                    _c("ShowLiquidez", {
                      attrs: { values: _vm.liquidezDireita, size: 0 }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c(
                  "div",
                  { staticClass: "az-card-bordered h-100" },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-between mb-10" },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex align-center" },
                          [
                            _c("h2", { staticClass: "az-ds-card-title" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.simulacaoEsquerda.hash
                                      ? _vm.simulacaoEsquerda.nome_simulacao
                                      : "Carteira atual"
                                  ) +
                                  " "
                              )
                            ]),
                            _c(
                              "v-tooltip",
                              {
                                attrs: { top: "" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "ml-1",
                                                attrs: {
                                                  icon: "",
                                                  "x-small": "",
                                                  "aria-label":
                                                    "Info dos ativos"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.moreInfo(
                                                      _vm.ativosEsquerda,
                                                      {
                                                        title: _vm
                                                          .simulacaoEsquerda
                                                          .hash
                                                          ? _vm
                                                              .simulacaoEsquerda
                                                              .nome_simulacao
                                                          : "Carteira atual",
                                                        subtitle:
                                                          "P/L: " +
                                                          _vm.toMoney(
                                                            _vm.pl_esquerda
                                                          )
                                                      }
                                                    )
                                                  }
                                                }
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c("icon-svg", {
                                              attrs: {
                                                name: "info-circle",
                                                size: 16
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ])
                              },
                              [_c("span", [_vm._v("Info dos ativos")])]
                            )
                          ],
                          1
                        ),
                        _c("div", [
                          _c(
                            "span",
                            { staticClass: "az-text-small az-muted d-block" },
                            [_vm._v("P/L:")]
                          ),
                          _c(
                            "span",
                            { staticClass: "az-text-primary font-bold" },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.toMoney(_vm.pl_esquerda)) + " "
                              )
                            ]
                          )
                        ])
                      ]
                    ),
                    _c("SimulatorPortfolioTable", {
                      attrs: {
                        headers: _vm.headerCarteiraSimples,
                        items: _vm.ativosEsquerda,
                        "group-by": _vm.modo,
                        "fixed-assets": _vm.novosAtivos,
                        "only-edit-notes": "",
                        "is-compact": "",
                        "max-tags-display": 1
                      },
                      on: {
                        "save-notes": _vm.handleSaveNotes,
                        "block-asset": _vm.bloquearAtivo,
                        "change-asset": _vm.trocarAtivo,
                        "fix-asset": _vm.fixarAtivo
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c(
                  "div",
                  { staticClass: "az-card-bordered h-100" },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-between mb-10" },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex align-center" },
                          [
                            _c("h2", { staticClass: "az-ds-card-title" }, [
                              _vm._v(" Carteira simulada ")
                            ]),
                            _c(
                              "v-tooltip",
                              {
                                attrs: { top: "" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "ml-1",
                                                attrs: {
                                                  icon: "",
                                                  "x-small": "",
                                                  "aria-label":
                                                    "Info dos ativos"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.moreInfo(
                                                      _vm.ativosDireita,
                                                      {
                                                        title:
                                                          "Carteira simulada",
                                                        subtitle:
                                                          "P/L: " +
                                                          _vm.toMoney(
                                                            _vm.pl_direita
                                                          )
                                                      }
                                                    )
                                                  }
                                                }
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c("icon-svg", {
                                              attrs: {
                                                name: "info-circle",
                                                size: 16
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ])
                              },
                              [_c("span", [_vm._v("Info dos ativos")])]
                            )
                          ],
                          1
                        ),
                        _c("div", [
                          _c(
                            "span",
                            { staticClass: "az-text-small az-muted d-block" },
                            [_vm._v(" P/L: ")]
                          ),
                          _c(
                            "span",
                            { staticClass: "az-text-primary font-bold" },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.toMoney(_vm.pl_direita)) + " "
                              )
                            ]
                          )
                        ])
                      ]
                    ),
                    _c("SimulatorPortfolioTable", {
                      attrs: {
                        headers: _vm.headerCarteiraSimulada,
                        items: _vm.ativosDireita,
                        "group-by": _vm.modo,
                        "fixed-assets": _vm.novosAtivos,
                        "only-edit-notes": "",
                        "is-compact": "",
                        "max-tags-display": 1
                      },
                      on: {
                        "save-notes": _vm.handleSaveNotes,
                        "block-asset": _vm.bloquearAtivo,
                        "change-asset": _vm.trocarAtivo,
                        "fix-asset": _vm.fixarAtivo
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "az-card-bordered" },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex align-center mb-10" },
                      [
                        _c("h2", { staticClass: "az-ds-card-title" }, [
                          _vm._v(" Movimentações ")
                        ]),
                        _c("v-spacer"),
                        _c("div", { staticClass: "text-right" }, [
                          _c(
                            "span",
                            { staticClass: "az-text-small az-muted d-block" },
                            [_vm._v(" Aportes: ")]
                          ),
                          _c(
                            "span",
                            { staticClass: "az-text-primary font-semibold" },
                            [_vm._v(" " + _vm._s(_vm.totalAportes) + " ")]
                          )
                        ]),
                        _c("div", { staticClass: "ml-10 text-right" }, [
                          _c(
                            "span",
                            { staticClass: "az-text-small az-muted d-block" },
                            [_vm._v(" Resgates: ")]
                          ),
                          _c(
                            "span",
                            { staticClass: "az-text-primary font-semibold" },
                            [_vm._v(" " + _vm._s(_vm.totalResgates) + " ")]
                          )
                        ])
                      ],
                      1
                    ),
                    _c("SimulatorOperationsTable", {
                      attrs: {
                        headers: _vm.headerCarteiraCompleta,
                        items: _vm.operacoes,
                        "group-by": _vm.modo,
                        "fixed-assets": _vm.novosAtivos
                      },
                      on: {
                        "save-notes": _vm.handleSaveNotes,
                        "fix-asset": _vm.fixarAtivo
                      }
                    })
                  ],
                  1
                )
              ]),
              _c(
                "v-scale-transition",
                [
                  !_vm.simulando && _vm.simulacaoDireita.hash_code
                    ? _c(
                        "ButtonAction",
                        { attrs: { color: "white" } },
                        [
                          _vm.simulacaoDireita.simulacao_salva ||
                          _vm.simulacaoDireita.expire_date
                            ? _c(
                                "div",
                                { staticClass: "d-flex align-center" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticStyle: {
                                        height: "70px !important"
                                      },
                                      attrs: {
                                        color: "white",
                                        tile: "",
                                        width: "200",
                                        depressed: ""
                                      },
                                      on: { click: _vm.toPermanent }
                                    },
                                    [
                                      _c("icon-svg", {
                                        staticClass: "mr-3",
                                        attrs: {
                                          name: "mdi-clock",
                                          color: "primary",
                                          size: 24
                                        }
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column align-start"
                                        },
                                        [
                                          !_vm.simulacaoDireita.simulacao_salva
                                            ? _c("div", [
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "az-text-small"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Simulação será apagada "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.getDistanceDate(
                                                            _vm.simulacaoDireita
                                                              .expire_date
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                ),
                                                _c("br"),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-primary mb-0"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Tornar permanente "
                                                    )
                                                  ]
                                                )
                                              ])
                                            : _c("div", [
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "az-text-small"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Simulação permanente "
                                                    )
                                                  ]
                                                )
                                              ])
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "d-flex align-center mx-2" },
                                    [
                                      _c("div", {
                                        staticStyle: {
                                          "border-right":
                                            "1px solid rgba(0, 0, 0, 0.12)",
                                          height: "40px"
                                        }
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.has_changes
                            ? _c(
                                "v-btn",
                                {
                                  staticStyle: { height: "70px !important" },
                                  attrs: {
                                    loading: _vm.loadingPDF,
                                    color: "white",
                                    tile: "",
                                    depressed: ""
                                  },
                                  on: { click: _vm.openSelectModelPDF }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column align-center"
                                    },
                                    [
                                      _c("icon-svg", {
                                        attrs: {
                                          name: "mdi-file-pdf-box",
                                          size: "18",
                                          color: "black"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "text-sm mt-1" },
                                        [_vm._v("Exportar")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          !_vm.has_changes
                            ? _c(
                                "v-btn",
                                {
                                  staticStyle: { height: "70px !important" },
                                  attrs: {
                                    hidden: "",
                                    color: "white",
                                    tile: "",
                                    depressed: "",
                                    loading: _vm.loadingCliente
                                  },
                                  on: { click: _vm.sendClient }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column align-center"
                                    },
                                    [
                                      _c("icon-svg", {
                                        attrs: {
                                          name: "mdi-send",
                                          size: "18",
                                          color: "black"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "text-sm mt-1" },
                                        [_vm._v("Mobile")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.SHOW_WORKSPACE
                            ? _c(
                                "v-btn",
                                {
                                  staticStyle: { height: "70px !important" },
                                  attrs: {
                                    color: "white",
                                    tile: "",
                                    depressed: ""
                                  },
                                  on: { click: _vm.openSendComponent }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column align-center"
                                    },
                                    [
                                      _c("icon-svg", {
                                        attrs: {
                                          name: "mdi-share-variant",
                                          size: "18",
                                          color: "black"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "text-sm mt-1" },
                                        [_vm._v("Workspace")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.restricoes_simulacao.tipo_simulador
                            ? _c(
                                "v-btn",
                                {
                                  staticStyle: { height: "70px !important" },
                                  attrs: {
                                    color: "white",
                                    tile: "",
                                    depressed: ""
                                  },
                                  on: { click: _vm.toRestricoes }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column align-center"
                                    },
                                    [
                                      _c("icon-svg", {
                                        attrs: {
                                          name: "mdi-pencil",
                                          size: "18",
                                          color: "black"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "text-sm mt-1" },
                                        [_vm._v("Alterar")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.has_changes
                            ? _c(
                                "v-btn",
                                {
                                  staticStyle: { height: "70px !important" },
                                  attrs: {
                                    color: "white",
                                    tile: "",
                                    depressed: ""
                                  },
                                  on: { click: _vm.simulateAgain }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column align-center"
                                    },
                                    [
                                      _c("icon-svg", {
                                        attrs: {
                                          name: "mdi-play-circle-outline",
                                          size: "18",
                                          color: "black"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "text-sm mt-1" },
                                        [_vm._v("Simular")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c("v-scale-transition", [
                _vm.simulando
                  ? _c(
                      "div",
                      {
                        staticClass: "v-application",
                        staticStyle: {
                          position: "fixed",
                          bottom: "0",
                          width: "40%",
                          margin: "auto",
                          "margin-bottom": "20px",
                          "z-index": "3",
                          left: "0",
                          right: "0"
                        }
                      },
                      [
                        _c("LoadingStatus", {
                          attrs: {
                            loading: _vm.simulando,
                            load: _vm.simulacaoDireita.load,
                            status: _vm.simulacaoDireita.status
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ],
            1
          ),
      _c("ModalPortfolioReviewEditNotes"),
      _c("ModalPesquisaHistorico", { attrs: { bus: _vm.busModal } }),
      _c("ModalTrocar", {
        attrs: {
          bus: _vm.busModal,
          fixados: [].concat(_vm.novosAtivos),
          "pl-total": _vm.pl_direita
        }
      }),
      _c("ModalRestricoes"),
      _c("ModalAmpliarTabela")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }